export function matchesFocusVisible(element) {
  try {
    return element.matches(':focus-visible');
  } catch {
    return element.matches('.focus-visible');
  }
}
